import React, {useCallback, useState } from 'react';
import {GoogleMap, useJsApiLoader, Marker } from '@react-google-maps/api';

const containerStyle = {
  width: '80%',
  height: '300px'
};

const center = {
  lat: 0.347596,
  lng: 32.582520 // Default to Kampala, Uganda
};

interface MapPickerProps {
  onLocationSelect: (lat: number, lng: number) => void;
  initialLocation?: {lat: number; lng: number};
}

const MapPicker: React.FC<MapPickerProps> = ({onLocationSelect, initialLocation }) => {
  const {isLoaded } = useJsApiLoader({
    googleMapsApiKey: "AIzaSyDhlZDiab1_FCVy0WRBeT7Y0KUc2ZXJIEM", 
    // Replace with your API Key
  });

  const [markerPosition, setMarkerPosition] = useState(initialLocation || center);

  const onMapClick = useCallback((e: google.maps.MapMouseEvent) => {
    if (e.latLng) {
      const newPosition = {
        lat: e.latLng.lat(),
        lng: e.latLng.lng(),
      };
      setMarkerPosition(newPosition);
      onLocationSelect(newPosition.lat, newPosition.lng);
    }
  }, [onLocationSelect]);

  return isLoaded ? (
    <GoogleMap
      mapContainerStyle={containerStyle}
      center={center}
      zoom={12}
      onClick={onMapClick}
    >
      <Marker position={markerPosition} />
    </GoogleMap>
  ) : <p>Loading map...</p>;
};

export default MapPicker;